// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\events-details.$eventId.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\events-details.$eventId.tsx");
  import.meta.hot.lastModified = "1760464886205.697";
}
// REMIX HMR END

import { Link, useParams } from "@remix-run/react";
import { Button } from "~/components/ui/button";
import { PublicRoute } from "~/components/RouteProtection";
export const meta = ({
  params
}) => {
  return [{
    title: `${params.eventId || 'Event'} Details - Nomadics Studios`
  }, {
    name: "description",
    content: "Join us for an unforgettable experience at Nomadics Studios events."
  }];
};

// Mock events data - this would typically come from your API
const eventsData = [{
  id: 1,
  title: "Test event",
  date: "Wednesday, 23 Jul AT 11:50 PM",
  organizer: "Super Admin",
  location: "Testing....",
  points: "100 Points",
  status: "public",
  description: "testing...",
  participants: {
    interested: 1,
    going: 110
  },
  image: "/event.png",
  slug: "test-event"
}, {
  id: 2,
  title: "Music event",
  date: "Saturday, 28 Jun AT 12:30 AM",
  organizer: "Super Admin",
  location: "ONLINE",
  points: "20 Points",
  status: "public",
  description: "Embark on a journey with Nomadic Events – where every moment becomes an adventure. Join us for an unforgettable experience filled with laughter, connection, and the thrill of exploring new horizons. It's more than an event; it's a celebration of wanderlust and shared stories. Be part of the Nomadic community and let the extraordinary unfold.",
  participants: {
    interested: 2,
    going: 20
  },
  image: "/bw (2).png",
  slug: "music-event"
}];

// Function to find event by slug or ID
function findEventBySlug(slug) {
  return eventsData.find(event => event.slug === slug || event.id.toString() === slug) || eventsData[0];
}
export default function EventDetailsPage() {
  _s();
  const {
    eventId
  } = useParams();
  const event = findEventBySlug(eventId || "");
  return <PublicRoute>
      <div className="relative bg-white min-h-screen">
        {/* Hero Section with Background Image */}
        <section className="relative h-[50vh] lg:h-[55vh] overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img src={event.image} alt={event.title} className="h-full w-full object-cover" onError={e => {
            e.currentTarget.src = "/event.png";
          }} />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/50 to-black/70" />
          </div>

          {/* Hero Content */}
          <div className="relative z-10 h-full flex items-end">
            <div className="mx-auto w-full max-w-[1000px] px-4 lg:px-8 pb-12 lg:pb-16">
              {/* Breadcrumb */}
              <nav className="mb-6">
                <Link to="/events" className="text-sm text-white/80 hover:text-white transition-colors uppercase tracking-wider flex items-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  Back to Events
                </Link>
              </nav>

              {/* Title */}
              <h1 className="text-3xl lg:text-5xl font-bold text-white mb-6 leading-tight max-w-4xl">
                {event.title}
              </h1>

              {/* Event Meta Info */}
              <div className="flex flex-col gap-2 text-white/90">
                <div className="text-lg font-medium">{event.date}</div>
                <div className="text-white/80">by {event.organizer}</div>
              </div>
            </div>
          </div>
        </section>

        {/* Event Details Section */}
        <section className="bg-gray-50 py-12 lg:py-16">
          <div className="mx-auto w-full max-w-[1000px] px-4 lg:px-8">
            
            {/* Share Button */}
            <div className="mb-8">
              <Button variant="outline-black" size="sm" className="bg-white text-black border-black hover:bg-black hover:text-white transition-colors duration-300">
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                </svg>
                Share
              </Button>
            </div>

            {/* Event Info Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {/* Left Column - Event Details */}
              <div className="space-y-6">
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex-shrink-0">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 mb-1">{event.participants.interested} User Interested /</div>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex-shrink-0">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-black font-medium">{event.date}</div>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex-shrink-0">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-black font-medium">{event.location}</div>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex-shrink-0">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-black font-medium">{event.points}</div>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex-shrink-0">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-black font-medium">{event.status}</div>
                  </div>
                </div>

                {/* Description */}
                <div className="pt-4">
                  <p className="text-gray-700 leading-relaxed">{event.description}</p>
                </div>
              </div>

              {/* Right Column - Participants */}
              <div>
                <h3 className="text-lg font-bold text-black mb-6">Participants</h3>
                
                <div className="flex gap-4 mb-8">
                  <Button variant="outline-black" size="md" className="flex-1 bg-white text-black border-black hover:bg-black hover:text-white transition-colors duration-300">
                    <div className="flex items-center gap-2">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                      </svg>
                      Interested 🔥
                    </div>
                  </Button>
                  
                  <Button variant="fill-black" size="md" className="flex-1">
                    <div className="flex items-center gap-2">
                      {event.participants.going} Points
                      <span>Going ➡</span>
                    </div>
                  </Button>
                </div>
              </div>
            </div>

            {/* Address Section */}
            <div className="mb-8">
              <h3 className="text-lg font-bold text-black mb-4">Address</h3>
              <p className="text-gray-700">{event.location}</p>
            </div>

            {/* Map Section */}
            <div className="mb-8">
              <div className="w-full h-96 bg-gray-200 rounded-lg overflow-hidden">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sus!4v1234567890123" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="rounded-lg"></iframe>
              </div>
            </div>
          </div>
        </section>
      </div>
    </PublicRoute>;
}
_s(EventDetailsPage, "2DtOgokhj4CBuNiepZNhzegCPbs=", false, function () {
  return [useParams];
});
_c = EventDetailsPage;
var _c;
$RefreshReg$(_c, "EventDetailsPage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;